import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { PROCESS_AG_COPROPRIETES } from '../../../../config/process-ag-coproprietes';

export default function ResolutionAgPage() {
  const item = PROCESS_AG_COPROPRIETES.find((p) => p.slug === 'resolution');
  if (!item) return null;
  return (
    <AudienceParcoursStubPage
      parcours={item}
      audienceId="coproprietes"
      segment="process-ag"
      segmentLabel="Process AG"
      ctaFinalOverride={{
        eyebrow: 'Sécuriser le vote',
        title: 'On vous aide à formuler la résolution',
        description:
          "On travaille avec votre syndic et votre conseil syndical pour que chaque résolution soit votée à la bonne majorité (art. 24, 25 ou 25-1), avec une rédaction qui tient en cas de recours. Sans jamais se substituer à votre syndic.",
        primary: { label: 'Cadrer ma résolution AG', href: '/contact?source=coproprietes&besoin=resolution-ag' },
        secondary: { label: 'Voir la stratégie de vote', href: '/coproprietes/process-ag/vote' },
        bullets: ['Conformité loi de 1965', 'Passerelle art. 25-1 anticipée', 'Aux côtés du syndic, pas à sa place'],
      }}
    />
  );
}
